import { FlowStepTypes, MenuTypes } from './flow-step-types.enum';

export const horizontOfset = 260;
export const verticalOfset = 25;
export const actionHeight = 120;
export const menuHeight = 120;
export const flowHeight = 120;
export const newStepHeight = 120;
export const newStepValue = 'NextStep';
export const endStepValue = '_MENU_END_';
export const newStepDescription = '';
export const newLine = '\n';
export const flowStepType: typeof FlowStepTypes = FlowStepTypes;
export const menuType: typeof MenuTypes = MenuTypes;
export const startStep = 'step1'; //start
export const reset = '__RESET__';
